import { setupWorker } from "msw/browser";
import { handlers } from "./handlers";

export const worker = setupWorker(...handlers);

/**
 * Start MSW when standalone mocking is enabled. Default-on in dev so the app
 * runs with no backend; set VITE_USE_MOCKS=false to hit live M/P services.
 */
export async function startMocks(): Promise<void> {
  const useMocks = import.meta.env.VITE_USE_MOCKS ?? "true";
  if (useMocks === "false") return;
  await worker.start({
    onUnhandledRequest: "bypass",
    quiet: true,
  });
}
